import { R } from "@mobily/ts-belt";

export const unwrapResult = <T, E>(result: R.Result<T, E>): T => {
  if (R.isOk(result)) return result._0;
  throw result._0;
};
